module.exports = __webpack_public_path__ + "img/signature.0fd3c3b5.gif";